import { Metadata, useTranslation } from "@bsm/component";
import { TTimeOff } from "@bsm/graphql"
import { useAppointmentEventColor } from "hooks/useAppointmentEventColor"

export const AppointmentDetailsType = (props: Props) => {

    const t = useTranslation()
    const className = useAppointmentEventColor(props)

    if (props.type) {
        return (
            <Metadata
                label={t("Project.DayOff.Type")}
                // className="items-start"
                value={( 
                    <h3 className={`font-bold`}>{t(`Generic.de.${props?.type?.designation}`)}</h3>
                )}
            />
        )
    }

    return (
        <></>
    )
}

type Props = Partial<TTimeOff>
